(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ng-cart-cross-sell'))customElements.define('ng-cart-cross-sell',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.addEventListener('click',event=>event.stopPropagation());
      this.querySelector('form').addEventListener('submit',async event=>{
        event.preventDefault();if(this.busy)return;this.busy=true;
        const button=this.querySelector('button');const status=this.querySelector('[role=status]');button.disabled=true;status.textContent='Wird hinzugefügt …';
        try{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(event.target),headers:{Accept:'application/json'}});
          const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||'Der Artikel konnte nicht hinzugefügt werden.');
          location.reload();
        }catch(error){status.textContent=error.message;this.busy=false;button.disabled=false;}
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-holzbau"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('[data-ng-holzbau]').forEach(section => {
      if (section.dataset.ngReady) return;
      section.dataset.ngReady = 'true';
      section.addEventListener('click', event => {
        const link = event.target.closest('[data-ng-product]');
        if (!link) return;
        const select = section.querySelector('[data-ng-select]');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.dataset.ngOption === link.dataset.ngProduct);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          requestAnimationFrame(() => section.querySelector('[data-ng-name]')?.focus({ preventScroll: true }));
        }
      });
      const form = section.querySelector('form');
      form?.addEventListener('submit', () => {
        const button = form.querySelector('[data-ng-submit]');
        if (button && form.checkValidity()) {
          button.disabled = true;
          button.dataset.ngOriginal = button.innerHTML;
          button.textContent = button.dataset.ngSending;
          setTimeout(() => {
            if (button.isConnected) {
              button.disabled = false;
              button.innerHTML = button.dataset.ngOriginal;
            }
          }, 15000);
        }
      });
      const status = section.querySelector('[data-ng-status]');
      if (status) status.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-ng-submit]').forEach(button => {
      button.disabled = false;
      if (button.dataset.ngOriginal) button.innerHTML = button.dataset.ngOriginal;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
